import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { OrganisationService } from 'src/services/organisation.service';
import { OrganisationModel } from 'src/models/pilotage/organisationModel';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { EditParametresOrganisationDialogComponent } from './edit-parametres-organisation-dialog/edit-parametres-organisation-dialog.component';

@Component({
    selector: 'app-parametres-organisations-managment',
    imports: [
    MatProgressSpinnerModule,
    TranslateModule,
    MatIconModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatOptionModule
],
    templateUrl: './parametres-organisations-managment.component.html',
    styleUrl: './parametres-organisations-managment.component.scss'
})
export class ParametresOrganisationsManagmentComponent implements OnInit {
  isLoading = false;
  searchTerm = '';
  filtreType: string = '';
  pageIndex = 0;
  pageSize = 10;
  totalItems = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  displayedColumns: string[] = [
    'nom',
    'aUtilisateursFictifs',
    'aAccesDiffusion',
    'aAccesIndex',
    'aTenantSSO',
    'neq',
    'idUnique',
    'type',
    'actions'
  ];

  dataSource!: MatTableDataSource<any>;
  allItems: any[] = [];
  filteredItems: any[] = [];
  affiches: any[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private organisationsService: OrganisationService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    public translate: TranslateService,
    private dialog: MatDialog
  ) {
    translate.setDefaultLang('fr');
    this.dataSource = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.isLoading = true;
    this.organisationsService.obtenirOrganisations().subscribe(
      (res) => {
        const groupes = (res.groupes || []).map(g => ({ ...g, type: 'Groupe' }));
        const entitesSeules = (res.entites || [])
          .filter(e => !e.groupeId)
          .map(e => ({ ...e, type: 'Entité seule' }));
        this.allItems = [...groupes, ...entitesSeules];
        this.filtre();
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  filtre(): void {
    this.applyFilters();
  }

  applyFilters(): void {
    let filtered = [...this.allItems];

    if (this.filtreType === 'Groupe') {
      filtered = filtered.filter(item => item.type === 'Groupe');
    } else if (this.filtreType === 'Entité seule') {
      filtered = filtered.filter(item => item.type === 'Entité seule');
    }

    if (this.searchTerm && this.searchTerm.length > 2) {
      const textRechercher = this.searchTerm.trim().toLowerCase();
      filtered = filtered.filter(item => {
        const checkValue = (value: any): boolean => {
          if (value && typeof value === 'object') {
            return Object.values(value).some(v => checkValue(v));
          }
          return value && String(value).toLowerCase().includes(textRechercher);
        };
        return Object.values(item).some(value => checkValue(value));
      });
    }
    this.filteredItems = filtered.sort((a, b) => {
      if (a.aUtilisateursFictifs === b.aUtilisateursFictifs) {
        return a.nom.localeCompare(b.nom, 'fr', { sensitivity: 'base' });
      }
      return b.aUtilisateursFictifs ? 1 : -1;
    });
    this.totalItems = this.filteredItems.length;
    this.pageIndex = 0;
    this.paginer();
  }

  paginer(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.affiches = this.filteredItems.slice(startIndex, endIndex);
    this.dataSource.data = this.affiches;
    this.changeDetectorRef.detectChanges();
  }

  sortDataChange(sortState: Sort) {
    if (!sortState.active || sortState.direction === '') {
      this.filteredItems = [...this.filteredItems];
    } else {
      const isAsc = sortState.direction === 'asc';
      this.filteredItems = this.filteredItems.sort((a, b) => {
        const valueA = (a[sortState.active] || '').toString().toLowerCase();
        const valueB = (b[sortState.active] || '').toString().toLowerCase();
        return isAsc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      });
    }
    this.paginer();
  }

  reinitialiserFiltre(): void {
    this.searchTerm = '';
    this.filtre();
  }

  editOrganisation(entiteId: number) {
    const dialogRef = this.dialog.open(EditParametresOrganisationDialogComponent, {
      data: { entiteId },
      width: '600px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.loadData();
    });
  }
}
